export const AssetTypeIds = {
  rollQcMachine: '69c612bce1ea131afad2124d', // Roll Quality Control Machine — used to filter QC machines in the Roll QC page
} as const;
